class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

/* Teeology: improve Size Guide and Style Guides readability. */
(function () {
  function addGuideStyles() {
    if (document.getElementById('teeology-guide-readability-styles')) return;

    const style = document.createElement('style');
    style.id = 'teeology-guide-readability-styles';
    style.textContent = `
      /* Product Size Guide */
      .teeology-size-guide-accordion .teeology-size-guide-content {
        padding: .4rem 0 2rem;
      }
      .teeology-size-guide-accordion .size-chart-text-content,
      .teeology-size-guide-accordion .size-chart-text-content p,
      .teeology-size-guide-accordion .size-chart-text-content strong {
        color: #f3eee4 !important;
        -webkit-text-fill-color: #f3eee4 !important;
      }
      .teeology-size-guide-accordion .size-chart-text-content {
        font-size: 1.5rem;
        line-height: 1.7;
        margin: .8rem 0 1.4rem;
      }
      .teeology-size-guide-accordion .size-chart-table-wrap {
        margin-top: 1.2rem;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }
      .teeology-size-guide-accordion .size-chart-table {
        width: 100%;
        min-width: 440px;
        table-layout: auto;
        border-collapse: collapse;
        background: #151515 !important;
        font-size: 1.4rem;
      }
      .teeology-size-guide-accordion .size-chart-table th {
        background: #d1a44d !important;
        color: #080808 !important;
        -webkit-text-fill-color: #080808 !important;
        border: 1px solid #6f5728 !important;
        padding: 1.2rem 1rem;
        font-weight: 900;
        text-transform: uppercase;
        letter-spacing: .04em;
        text-align: center;
      }
      .teeology-size-guide-accordion .size-chart-table td {
        color: #f3eee4 !important;
        -webkit-text-fill-color: #f3eee4 !important;
        border: 1px solid rgba(243, 238, 228, .25) !important;
        padding: 1.1rem 1rem;
        text-align: center;
      }
      .teeology-size-guide-accordion .size-chart-table td:first-child {
        color: #d6b86f !important;
        -webkit-text-fill-color: #d6b86f !important;
        font-weight: 900;
        text-align: left;
      }
      .teeology-size-guide-accordion .size-chart-table tbody tr:nth-child(odd) {
        background: #151515 !important;
      }
      .teeology-size-guide-accordion .size-chart-table tbody tr:nth-child(even) {
        background: #1e1e1e !important;
      }
      .teeology-size-guide-accordion .size-chart-note {
        color: #d7d0c4 !important;
        -webkit-text-fill-color: #d7d0c4 !important;
        font-size: 1.25rem;
        line-height: 1.55;
        margin-top: 1rem;
      }
      .teeology-size-guide-accordion .size-chart-img {
        display: block;
        width: 100%;
        height: auto;
      }
      .teeology-size-guide-caret {
        margin-left: auto;
        font-size: 1.8rem;
        line-height: 1;
        transition: transform .2s ease;
      }
      .teeology-size-guide-accordion details[open] .teeology-size-guide-caret {
        transform: rotate(180deg);
      }

      /* Style Guides blog listing (/blogs/news) */
      .main-blog {
        color: #f3eee4;
      }
      .main-blog .title--primary {
        color: #f3eee4 !important;
        -webkit-text-fill-color: #f3eee4 !important;
        font-weight: 900 !important;
        line-height: 1.08;
        text-transform: uppercase;
        letter-spacing: -.02em;
      }
      .main-blog .blog-articles {
        row-gap: 3rem;
      }
      .main-blog .article-card,
      .main-blog .article-card .card__inner {
        background: #151515 !important;
      }
      .main-blog .article-card {
        border: 1px solid #3b3120;
      }
      .main-blog .article-card .card__information {
        padding: 2rem !important;
      }
      .main-blog .article-card .card__heading,
      .main-blog .article-card .card__heading a {
        color: #f3eee4 !important;
        -webkit-text-fill-color: #f3eee4 !important;
        font-weight: 900 !important;
        line-height: 1.2;
      }
      .main-blog .article-card:hover .card__heading a {
        color: #d6b86f !important;
        -webkit-text-fill-color: #d6b86f !important;
      }
      .main-blog .article-card__info {
        color: #d6b86f !important;
        -webkit-text-fill-color: #d6b86f !important;
        font-size: 1.2rem !important;
        font-weight: 700;
      }
      .main-blog .article-card__excerpt,
      .main-blog .article-card__footer {
        color: #d7d0c4 !important;
        -webkit-text-fill-color: #d7d0c4 !important;
      }
      .main-blog .article-card__excerpt {
        font-size: 1.5rem !important;
        line-height: 1.7;
      }

      /* Style Guide article pages */
      .article-template {
        color: #f3eee4;
      }
      .article-template__title {
        color: #f3eee4 !important;
        -webkit-text-fill-color: #f3eee4 !important;
        font-weight: 900 !important;
        line-height: 1.08;
        letter-spacing: -.025em;
      }
      .article-template header .caption-with-letter-spacing,
      .article-template header time {
        color: #d6b86f !important;
        -webkit-text-fill-color: #d6b86f !important;
      }
      .article-template__content {
        max-width: 84rem;
        font-size: 1.65rem;
        line-height: 1.8;
        color: #e8e2d7 !important;
      }
      .article-template__content p,
      .article-template__content li,
      .article-template__content span,
      .article-template__content em {
        color: #e8e2d7 !important;
        -webkit-text-fill-color: #e8e2d7 !important;
      }
      .article-template__content strong,
      .article-template__content b {
        color: #f3eee4 !important;
        -webkit-text-fill-color: #f3eee4 !important;
      }
      .article-template__content h1,
      .article-template__content h2,
      .article-template__content h3,
      .article-template__content h4 {
        color: #f3eee4 !important;
        -webkit-text-fill-color: #f3eee4 !important;
        font-weight: 900 !important;
        line-height: 1.15;
      }
      .article-template__content h2 {
        font-size: clamp(2.4rem, 4vw, 3.4rem);
        margin-top: 4rem;
        margin-bottom: 1.5rem;
      }
      .article-template__content h3 {
        color: #d6b86f !important;
        -webkit-text-fill-color: #d6b86f !important;
        font-size: 2.2rem;
        margin-top: 3rem;
      }
      .article-template__content a,
      .article-template__content a span,
      .article-template__content a strong,
      .article-template__link {
        color: #d6b86f !important;
        -webkit-text-fill-color: #d6b86f !important;
      }
      .article-template__content a {
        text-decoration-thickness: .12rem;
        text-underline-offset: .2rem;
      }
      .article-template__content table {
        width: 100% !important;
        table-layout: auto !important;
        border-collapse: collapse;
        background: #151515 !important;
        color: #f3eee4 !important;
        font-size: 1.45rem;
        margin: 2.4rem 0;
      }
      .article-template__content table th {
        background: #d1a44d !important;
        color: #080808 !important;
        -webkit-text-fill-color: #080808 !important;
        font-weight: 900 !important;
        padding: 1.2rem 1rem;
        border: 1px solid #6f5728 !important;
      }
      .article-template__content table td {
        color: #f3eee4 !important;
        -webkit-text-fill-color: #f3eee4 !important;
        padding: 1.1rem 1rem;
        border: 1px solid rgba(243, 238, 228, .22) !important;
      }
      .article-template__content table tr:nth-child(even) td {
        background: #1e1e1e !important;
      }
      .article-template__content blockquote {
        border-left: .3rem solid #d1a44d;
        background: #151515;
        color: #f3eee4 !important;
        padding: 1.5rem 1.8rem;
      }

      @media screen and (max-width: 749px) {
        .teeology-size-guide-accordion .size-chart-text-content {
          font-size: 1.4rem;
        }
        .teeology-size-guide-accordion .size-chart-table {
          min-width: 400px;
          font-size: 1.2rem;
        }
        .teeology-size-guide-accordion .size-chart-table th,
        .teeology-size-guide-accordion .size-chart-table td {
          padding: .9rem .7rem;
        }
        .main-blog .title--primary {
          font-size: 3rem !important;
        }
        .main-blog .article-card .card__information {
          padding: 1.6rem !important;
        }
        .main-blog .article-card__excerpt {
          font-size: 1.4rem !important;
          line-height: 1.65;
        }
        .article-template__title {
          font-size: 3.2rem !important;
        }
        .article-template__content {
          font-size: 1.5rem;
          line-height: 1.75;
        }
        .article-template__content table {
          display: block;
          max-width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          white-space: nowrap;
          font-size: 1.25rem;
        }
        .article-template__content table th,
        .article-template__content table td {
          padding: .9rem .7rem;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function buildSizeGuideAccordion(trigger) {
    if (!trigger || trigger.dataset.teeologyAccordionReady === 'true') return;

    const prefix = 'size-chart-btn-';
    const triggerId = trigger.id || '';
    if (!triggerId.startsWith(prefix)) return;

    const sectionId = triggerId.slice(prefix.length);
    const modal = document.getElementById(`size-chart-modal-${sectionId}`);
    const content = modal?.querySelector('.size-chart-content');
    const triggerWrap = trigger.closest('.product-form__buttons');
    if (!modal || !content || !triggerWrap) return;

    trigger.dataset.teeologyAccordionReady = 'true';

    const accordion = document.createElement('div');
    accordion.className = 'product__accordion accordion quick-add-hidden teeology-size-guide-accordion';
    accordion.dataset.teeologySizeGuide = 'true';

    const details = document.createElement('details');
    details.id = `Details-SizeGuide-${sectionId}`;

    const summary = document.createElement('summary');
    const summaryTitle = document.createElement('div');
    summaryTitle.className = 'summary__title';

    const triggerIcon = trigger.querySelector('.svg-wrapper, svg, img');
    if (triggerIcon) summaryTitle.appendChild(triggerIcon.cloneNode(true));

    const heading = document.createElement('h2');
    heading.className = 'h4 accordion__title inline-richtext';
    heading.textContent = (trigger.querySelector('.size-chart-text')?.textContent || 'SIZE GUIDE').trim().toUpperCase();
    summaryTitle.appendChild(heading);
    summary.appendChild(summaryTitle);

    const existingCaret = document.querySelector('.product__accordion summary .icon-caret');
    if (existingCaret) {
      summary.appendChild(existingCaret.cloneNode(true));
    } else {
      const fallbackCaret = document.createElement('span');
      fallbackCaret.className = 'teeology-size-guide-caret';
      fallbackCaret.setAttribute('aria-hidden', 'true');
      fallbackCaret.textContent = '⌄';
      summary.appendChild(fallbackCaret);
    }

    const body = document.createElement('div');
    body.className = 'accordion__content rte teeology-size-guide-content';
    content.querySelector('.product-popup-modal__toggle')?.remove();
    while (content.firstChild) body.appendChild(content.firstChild);

    details.appendChild(summary);
    details.appendChild(body);
    accordion.appendChild(details);

    triggerWrap.replaceWith(accordion);
    modal.remove();
  }

  function convertSizeGuides() {
    document.querySelectorAll('[id^="size-chart-btn-"]').forEach(buildSizeGuideAccordion);
  }

  function startGuideEnhancements() {
    addGuideStyles();
    convertSizeGuides();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGuideEnhancements, { once: true });
  } else {
    startGuideEnhancements();
  }

  document.addEventListener('product-info:loaded', function () {
    if (document.readyState === 'loading') return;
    setTimeout(convertSizeGuides, 0);
  });
})();
